export interface ShowMoreLabels {
  showLessLabel?: string;
  showMoreLabel?: string;
}

/**
 * Contentful carries both toggle labels in the single `faqCategory.showMoreLabel`
 * field, e.g. "Bekijk meer / Bekijk minder". Split on the FIRST slash so the
 * show-less side may itself contain slashes. Blank sides are omitted so the
 * FaqAccordion component defaults apply.
 */
export const splitShowMoreLabel = (label?: string | null): ShowMoreLabels => {
  const trimmed = label?.trim();
  if (!trimmed) {
    return {};
  }

  const separatorIndex = trimmed.indexOf('/');
  if (separatorIndex === -1) {
    return { showMoreLabel: trimmed };
  }

  const showMoreLabel = trimmed.slice(0, separatorIndex).trim();
  const showLessLabel = trimmed.slice(separatorIndex + 1).trim();

  return {
    ...(showLessLabel ? { showLessLabel } : {}),
    ...(showMoreLabel ? { showMoreLabel } : {}),
  };
};

/**
 * Sort by `order` ascending, non-mutating. Items without an order (missing or
 * null — the field only exists once Contentful migration 0197 lands) sort
 * after ordered ones and keep their relative array position (stable sort).
 */
export const sortFaqItemsByOrder = <T extends { order?: number | null }>(items: readonly T[]): T[] =>
  [...items].sort((a, b) => {
    const aOrder = a.order ?? null;
    const bOrder = b.order ?? null;

    if (aOrder === null && bOrder === null) {
      return 0;
    }
    if (aOrder === null) {
      return 1;
    }
    if (bOrder === null) {
      return -1;
    }
    return aOrder - bOrder;
  });
